import { HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { tap } from 'rxjs';
import { environments } from '../../../environments/environment';
import { CsrfBootstrapService } from '../services/csrf-bootstrap.service';

export const csrfRefreshInterceptor: HttpInterceptorFn = (req, next) => {
  const csrfBootstrap = inject(CsrfBootstrapService);

  return next(req).pipe(
    tap(event => {
      if (
        event instanceof HttpResponse &&
        req.url.startsWith(environments.apiUrl)
      ) {
        csrfBootstrap.captureToken(event);
      }
    })
  );
};
